export const environment = {
    // development, uat, production, local
    environmentType: 'production',
    production: false,
    versionCheckURL: './version.json',
    apiUrl: 'https://prd-va-curapatient.fed.curapatient.com',
    webUrl: 'https://prd-va-curapatient.fed.curapatient.com',
    apiSocketUrl: 'https://curapatient-be-ws.prd-hcc.curapatient.com',
    apiSocketUrl2: 'https://prd-va-curapatient.fed.curapatient.com',
    name: 'prod',
    carePlanId: 1314,
    defaultPODClinicId: 'bc11dc8d-3141-4dd9-a1fd-d4ef1c3bd9f4',
    patientRegistration: {
        assessmentId: 338,
        organizationId: 'e88ed8a5-e28b-4e01-99a7-dc44dc44920f',
    },
    sso: {
        client_id: '6smvpf6fo6vug3dtc83i7irsfs',
        auth_url: 'https://prd-hcc-curapatient.auth-fips.us-gov-west-1.amazoncognito.com/login',
        cognitoUrl: 'https://dev-va-curapatient.auth-fips.us-gov-west-1.amazoncognito.com/oauth2/authorize?client_id=oiavjq3frgkiqqo0p37sk8ugj&response_type=token&scope=email+openid+profile&redirect_uri=https://dev-va.fed.curapatient.com/login',
    },
    ssoI: {
        cognitoUrl:
            'https://dev-va-curapatient.auth-fips.us-gov-west-1.amazoncognito.com/oauth2/authorize?client_id=7pkabuddiul86gl8ask1v34hb1&response_type=token&scope=openid+profile&redirect_uri=https%3A%2F%2Fdev-va.fed.curapatient.com%2Flogin',
    },
};
